// https://www.algolia.com/doc/integration/shopify/building-search-ui/frontend-custom-events/?client=ruby#beforeautocompleteoptions
document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function(options) {
    
    // Change the placeholder text of the autocomplete menu
    //console.log( 'options', options );
    options.detachedMediaQuery = 'none';
    return options;
  });
});




// https://www.algolia.com/doc/integration/shopify/building-search-ui/frontend-custom-events/?client=ruby#beforeautocompleteproducttemplate
document.addEventListener("algolia.hooks.initialize", function () {
  
  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteProductTemplate",
    function (_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
      // Modify default options, then return them
      const { html, item, components } = templateOptions;
      return html`
      <a
        href="${itemLink}"
        class="aa-ItemLink aa-ProductItem"
        onClick="${() => trackSearchAttribution(item)}"
      >
        <div class="aa-ItemContent">
          <div class="aa-ItemPicture aa-ItemPicture--loaded">
            <img
              src="${algoliaShopify.helpers.largeImage(item)}"
              alt="${item.title}"
            />
          </div>
          <div class="aa-ItemContentBody">
            
            <div class="aa-ItemContentTitleWrapper">
              <div class="aa-ItemContentTitle">
                ${components.Highlight({ hit: item, attribute: "title" })}
                <span class="algolia-variant">
                  ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
                </span>
              </div>
            </div>
            <div class="aa-ItemContentPrice">
              <div class="aa-ItemContentPriceCurrent">
                ${algoliaShopify.helpers.displayPrice(item, distinct)}
              </div>
            </div>
          </div>
        </div>
      </a>
    `;
      
      //algoliaShopify.hooks.handleItemClick(item);
    }
  );
});

// https://www.algolia.com/doc/integration/shopify/building-search-ui/frontend-custom-events/?client=ruby#beforeautocompletenoresultstemplate
document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeAutocompleteNoResultsTemplate', function(_defaultTemplate, templateOptions) {
    const { html, state } = templateOptions;
    return html`
      <div class="aa-PanelLayout aa-Panel--scrollable">
        <p class="aa-NoResultsHeader">
          ${algoliaShopify.translation_helpers.no_result_for(state.query)}
          <!--No result for query  "${state.query}".-->
        </p>
      </div>
    `;
  });
});